export default __webpack_public_path__ + "static/designer-kyle-5b5bd92fc243970cea38ed009dbb840b.jpg";